// src/routes.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute';
import Settings from './pages/Settings';
import CourierLogin from './pages/CourierLogin';
import ForgotPassword from './pages/ForgotPassword';
import ResetPasswordConfirm from './pages/ResetPasswordConfirm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const AppRoutes = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/" element={<Login />} />
    <Route path="/courier" element={<CourierLogin />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/confirm-password" element={<ResetPasswordConfirm />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-of-service" element={<TermsOfService />} />

    {/* Redirect old dashboard route to admin */}
    <Route path="/dashboard" element={<Navigate to="/admin" replace />} />

    {/* Private Routes - Adira Logistics */}
    <Route path="/settings" element={<PrivateRoute element={Settings} />} />
  </Routes>
);

export default AppRoutes;
